import React from "react";
var __jsx = React.createElement;
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { UnstyledButton } from "@mantine/core";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Horizontal tab strip for switching between report versions inside an expanded report card. */
export function ReportVersionTabs(_ref) {
  var versions = _ref.versions,
    activeVersionId = _ref.activeVersionId,
    onVersionChange = _ref.onVersionChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex px-3.5 bg-sds-base-default border-b border-sds-base-default"
  }, versions.map(function (version, index) {
    var isActive = version.id === activeVersionId;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: version.id
    }, index > 0 && /*#__PURE__*/React.createElement("span", {
      className: "self-center h-3.5 w-px shrink-0 border-l border-sds-base-default"
    }), /*#__PURE__*/React.createElement(UnstyledButton, {
      "data-testid": "report-version-tab-".concat(version.id),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.REPORT_VERSION_TAB, {
          versionId: version.id
        });
        onVersionChange(version.id);
      },
      className: ["relative flex shrink-0 items-center gap-1.5 px-2.5 pt-[7px] pb-[8px] whitespace-nowrap transition-colors duration-150", isActive ? "text-style-label-emphasis text-sds-brand-default after:content-[''] after:absolute after:inset-x-0 after:-bottom-px after:h-[3px] after:bg-teal-500 dark:after:bg-teal-400" : "text-style-label-base text-sds-base-secondary hover:text-sds-base-default hover:bg-sds-base-secondary"].join(" ")
    }, version.label || t("label.report", {
      defaultValue: "Report"
    }), version.date && /*#__PURE__*/React.createElement("span", {
      className: "text-style-label-small text-sds-base-tertiary"
    }, version.date)));
  }));
}